import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Link,
  Stack,
  Text,
  useColorModeValue
} from '@chakra-ui/react'

import { FaCheckCircle } from 'react-icons/fa'

import Stars from './stars'

// One verified member. Everything below the name is filled in by the member
// themselves, so every field has to survive being empty.
const VerifiedServiceCard = ({ member, myRating, onRate }) => {
  const cardBg = useColorModeValue('white', 'main-gray')
  const cardColor = useColorModeValue('black', 'white')

  const initials = (member.name || '?')
    .replace(/\[.*?\]/g, '')
    .trim()
    .slice(0, 2)
    .toUpperCase()

  return (
    <Flex direction="column" bg={cardBg} color={cardColor} p="15px" h="full">
      <Flex align="center" mb={3}>
        {member.avatarImage ? (
          <Image
            src={member.avatarImage}
            alt={member.name}
            boxSize="46px"
            borderRadius="full"
            objectFit="cover"
            mr={3}
            flexShrink={0}
          />
        ) : (
          <Flex
            boxSize="46px"
            borderRadius="full"
            bg="light-gray"
            color="white"
            align="center"
            justify="center"
            fontSize={14}
            fontWeight={700}
            mr={3}
            flexShrink={0}
          >
            {initials}
          </Flex>
        )}

        <Box flex={1} minW={0}>
          <Flex align="center">
            <Heading fontSize={16} fontWeight={700} noOfLines={1}>
              {member.name}
            </Heading>
            <Box ml={2} flexShrink={0} title="Verified by the admin team">
              <FaCheckCircle color="var(--chakra-colors-main-green)" />
            </Box>
          </Flex>

          {member.ingameName && (
            <Text fontSize={12} opacity={0.6} noOfLines={1}>
              IGN: {member.ingameName}
            </Text>
          )}

          <Stars
            averageScore={member.averageScore}
            ratingCount={member.ratingCount}
          />
        </Box>

        {member.availabilityLabel && (
          <Text
            fontSize={11}
            fontWeight={700}
            letterSpacing={1}
            textTransform="uppercase"
            whiteSpace="nowrap"
            alignSelf="flex-start"
            flexShrink={0}
            ml={2}
            px={2}
            py={1}
            color="white"
            bg={member.isAvailable ? 'main-green' : 'light-gray'}
          >
            {member.availabilityLabel}
          </Text>
        )}
      </Flex>

      {member.description && (
        <Text fontSize={13} mb={3} whiteSpace="pre-wrap">
          {member.description}
        </Text>
      )}

      {member.fee !== null && member.fee !== undefined && (
        <Box mb={3}>
          <Text
            as="span"
            fontSize={12}
            border="1px solid"
            borderColor="light-gray"
            px={2}
            py={1}
          >
            Fee: {Number(member.fee)}
          </Text>
        </Box>
      )}

      <Stack direction="row" mt="auto" spacing={2} flexWrap="wrap">
        {member.contactLink && (
          <Link
            href={member.contactLink}
            isExternal
            _hover={{ textDecoration: 'none' }}
          >
            <Button variant="maroon-mini">MESSAGE</Button>
          </Link>
        )}
        {member.socialLink && (
          <Link
            href={member.socialLink}
            isExternal
            _hover={{ textDecoration: 'none' }}
          >
            <Button
              variant="outline-mini"
              color={cardColor}
              borderColor={cardColor}
            >
              SOCIAL
            </Button>
          </Link>
        )}
        <Button
          variant="outline-mini"
          color={cardColor}
          borderColor={cardColor}
          onClick={() => onRate(member)}
        >
          {myRating ? 'EDIT RATING' : 'RATE'}
        </Button>
      </Stack>
    </Flex>
  )
}

export default VerifiedServiceCard
